
import ArrowRight3 from "../../../assets/filled/ArrowRight3.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ArrowRight3Icon({ className, dataTestid = "ArrowRight3Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ArrowRight3 data-testid={dataTestid} className={classes} {...rest} />
  );
}
